module.exports = __webpack_public_path__ + "media/src/Checkout/Images/Icons/calendar-82f9023876ae135511fdfef7fa63ff24eba100a4ef5361b367859b879c8c596b.svg";